<h5>Last Message Event</h5>
<pre *ngIf="message$ | async as message; else none"
  >{{ message | json }}
</pre>
<ng-template #none> None </ng-template>
